import React from 'react';
import { useTranslation } from 'react-i18next';

import { SegmentedControl } from '../../../core-components/theme/components/SegmentedControl';
import type { SegmentedOption } from '../../../core-components/theme/components/SegmentedControl';
import { LANGUAGE_CHOICES, LANGUAGE_NAMES, LANGUAGE_SHORT, languageChoiceOf } from '../../../i18n/languages';

const LANGUAGE_OPTIONS: SegmentedOption[] = LANGUAGE_CHOICES.map((lng) => ({
  value: lng,
  label: LANGUAGE_SHORT[lng],
  lang: lng,
  ariaLabel: LANGUAGE_NAMES[lng],
}));

export const LanguageToggle: React.FC = () => {
  const { t, i18n } = useTranslation();
  return (
    <SegmentedControl
      aria-label={t('passcodeAuth.login.language', 'Language')}
      value={languageChoiceOf(i18n.language)}
      options={LANGUAGE_OPTIONS}
      onChange={(value) => {
        void i18n.changeLanguage(value);
      }}
    />
  );
};
